import { parseISO, isFuture, isPast } from 'date-fns'
import type { AsyncData } from 'nuxt/app'
import type { FetchError } from 'ofetch'

interface PromotionItem {
  id?: number
  row: number,
  style: string,
  link?: string,
  showLink: boolean,
  showOnSlug: string[],
  hideOnSlug: string[],
  showOnProduct?: any[],
  content: string | string[],
  validFrom: string,
  validUntil: string
}

export const usePromotions = () => {
  const { $api } = useNuxtApp()
  const promotions:Ref<PromotionItem[] | null> = useState(() => ref([]))

  const loadPromotions = async () => {
    promotions.value = null
    const { data } = await useAsyncData('promotions', () => $api('promotions')) as AsyncData<PromotionItem[], FetchError>
    promotions.value = data.value
    return data
  }

  const promotionsForSlug = ({ lang, slug, total, productsPerRow } : {lang: string, slug: string, total: number, productsPerRow:number}) => {
    if (!promotions.value) { return }

    // Look for slug match in promotion items
    const data = promotions.value.filter((item: PromotionItem) => {
      if (
        (item.showOnSlug.includes(lang + '/*') || item.showOnSlug.includes('*')) &&
        !item.hideOnSlug.includes(slug) &&
        isPast(parseISO(item.validFrom)) &&
        isFuture(parseISO(item.validUntil))
      ) {
        return true
      }
      return item.showOnSlug.includes(slug) && isPast(parseISO(item.validFrom)) && isFuture(parseISO(item.validUntil))
    })

    const rows: number[] = []
    // When promotions have duplicate rows, push it 3 rows further

    const normalizedData = data.map((item: PromotionItem) => {
      if (rows.includes(item.row)) {
        // When more then 16 products, push it 3 rows further, otherwise delete it.
        if (total > (16 * rows.length) && rows.length) {
          item.row = rows[rows.length - 1] + 3
        } else {
          item.row = -1
        }
      }

      rows.push(item.row)
      return item
    }).filter(item => item.row > 0 && item.row < (total / (productsPerRow - 1))) // -1 for rendering the promo before it scrolls into view

    return normalizedData
  }

  return { promotions, loadPromotions, promotionsForSlug }
}
